import gql from "graphql-tag";

// Get Client Status
export const gqlGetClientStatus = gql`
    query getClientInfo {
        clientInfo {
            id
            status
            checkpoint
            type
            payrollContribution {
                status
            }
            services {
                type
                corporate {
                    id
                    name
                    shortName
                    security {
                        id
                        name
                    }
                    feePercentage
                    activeShareTransferScheme {
                        name
                        active
                    }
                    payrollContributionScheme {
                        active
                    }
                }
            }
        }
    }
`

export const gqlGetClientInfo = gql`
    query getClientInfo {
        clientInfo {
            id
            firstName
            middleName
            lastName
            status
            email
            phone
            checkpoint
            externalReference
            type
            birthdateVerificationStatus
            targetRetirementAge
            employmentStatus
            annualIncome
            maritalStatus
            features {
                withdrawalsAllowed
                documentScanEnabled
                bankAccountManagementAllowed
                tinkPreselectionEnabled
                birthdateVerificationRequired
                kycRequired
                onboardingVia
                taxLimitsEnabled
                appDisabled
                dashboardDisabled
                documentsDisabled
            }
            announcement {
                id
                title
                message
                clientTypes
                startsAt
                endsAt
            }
            address {
                street
                town
                postCode
                country
                buildingNumber
                flatNumber
                buildingName
            }
        }
    }
`



export const gqlGetClientServices = gql`
    query getClientInfo {
        clientInfo {
            id
            type
            phone
            services {
                type
                corporate {
                    id
                    name
                    shortName
                    security {
                        id
                        name
                    }
                    feePercentage
                    activeShareTransferScheme {
                        name
                        active
                    }
                    payrollContributionScheme {
                        active
                    }
                }
            }
        }
    }
`

export const gqlGetClientBirthdate = gql`
    query getClientInfo {
        clientInfo {
            id
            birthdate
            birthdateVerificationStatus
        }
    }
`

// Get Client Preferences
export const gqlGetClientPreferences = gql`
    query getClientInfo {
        clientInfo {
            id
            type
            preferences {
                communication {
                    paperlessStatements
                }
                security {
                    smsMfa
                }
                marketing {
                    marketingUpdates
                }
            }
        }
    }
`

// Update Client Preferences
export const gqlUpdateClientPreferences = gql`
    mutation UpdateBoolPreference(
        $preferenceType: ClientPreferenceType!,
        $value: Boolean!
    ) {
        updateBoolPreference(
            boolPreferenceInput: {
                preferenceType: $preferenceType,
                value: $value
            }
        ){
            communication {
                paperlessStatements
            }
        }
    }
`

// Verify Client DoB
export const gqlVerifyBirthdate = gql`
    mutation VerifyBirthdate(
        $birthdate: AWSDate!
    ) {
        verifyBirthdate(
            birthdate: $birthdate,
        ){
            birthdateVerificationStatus
        }
    }
`
// Articles Related Queries
export const gqlClientArticlesPage = gql`
    query ClientArticlesPage($size: Int!, $page: Int!, $type: [ArticleType!]) {
        clientInfo {
            id
            articles(size: $size, page: $page, type: $type) {
                elements {
                    id
                    title
                    type
                    text
                    vimeoId
                    document {
                        id
                        url
                        name
                        status
                        createdAt
                        thumbnailUrl
                    }
                    createdAt
                    publishedAt
                    image {
                        id
                        url
                        name
                        status
                        createdAt
                        thumbnailUrl
                    }
                    pdf {
                        id
                        url
                        name
                        status
                        createdAt
                        thumbnailUrl
                    }
                    thumbnail {
                        id
                        url
                        name
                        status
                        createdAt
                        thumbnailUrl
                    }
                }
                pageInfo {
                    totalElements
                    totalPages
                    nextPageNumber
                }
            }
        }
    }
`

export const gqlClientMarketNewsArticlesPage = gql`
    query ClientArticlesPage($size: Int!, $page: Int!) {
        clientInfo {
            id,
            articles(size: $size, page: $page, type: [WEEKLY_UPDATE, MARKET_UPDATE]) {
                elements {
                    id
                    title
                    type
                    text
                    vimeoId
                    document {
                        id
                        url
                        name
                        status
                        createdAt
                        thumbnailUrl
                    }
                    createdAt
                    publishedAt
                }
                pageInfo {
                    totalElements
                    totalPages
                    nextPageNumber
                }
            }
        }
    }
`

export const gqlClientArticleItem = gql`
    query ClientArticlesPage($postId: ID!) {
        clientInfo {
            id
            article(id: $postId) {
                id
                title
                type
                text
                vimeoId
                document {
                    id
                    url
                    name
                    status
                    createdAt
                    thumbnailUrl
                }
                image {
                        id
                        url
                        name
                        status
                        createdAt
                        thumbnailUrl
                    }
                    pdf {
                        id
                        url
                        name
                        status
                        createdAt
                        thumbnailUrl
                    }
                    thumbnail {
                        id
                        url
                        name
                        status
                        createdAt
                        thumbnailUrl
                    }
                createdAt
                publishedAt
            }
        }
    }
`



export const gqlGetClientActiveDiversifyRequests = gql`
    query getClientInfo ($size: Int!, $page: Int!) {
        clientInfo {
            id
            type
            activeDiversifyRequests(size: $size, page: $page) {
                elements {
                    id
                    portfolio {
                        id
                    }
                    destinationPortfolio {
                        id
                    }
                    security {
                        id
                        name
                        isin
                        marketRegion
                    }
                    unitsAmount
                    status
                    createdAt
                    settledAmount
                    transaction {
                        id
                        status
                        type
                    }
                    destinationPortfolioTransaction {
                        id
                        status
                        type
                    }
                }
                pageInfo {
                    totalElements
                    totalPages
                    nextPageNumber
                }
            }
        }
    }
`

export const gqlMarkAnnouncementRead = gql`
    mutation MarkAnnouncementRead(
        $announcementId: ID!
    ) {
        markAnnouncementRead(
            announcementId: $announcementId,
        ){
            id
        }
    }
`

export const gqlGetClientAppointment = gql`
    query getClientInfo {
        clientInfo {
            id
            nextAppointment {
                scheduledAt
                name
                description
                adviser {
                    fullName
                    title
                    bio
                    imageUrl
                }
                meetingUrl
            }
        }
    }
`

export const gqlGetClientEmailAndExternalReference = gql`
    query getClientEmailAndExternalReference {
        clientInfo {
            id
            email
            externalReference
        }
    }
`
